export default __webpack_public_path__ + "static/media/BackgroundAboutus.ce0730d0.png";